
export const getTranslationByLocale = (translatable, locale) => {
  if (translatable && translatable.length > 0) {
    let translationIndex = -1;
    let enIndex = 0;
    for (let index = 0; index < translatable.length; index += 1) {
      if (translatable[index] && translatable[index].lang === locale && translatable[index].content) {
        translationIndex = index;
      }
      if (translatable[index] && translatable[index].lang === 'en' && translatable[index].content) {
        enIndex = index;
      }
    }
    if (translationIndex === -1) {
      translationIndex = enIndex;
    }
    if (translationIndex === -1) {
      translationIndex = 0;
    }
    return translatable[translationIndex] ? translatable[translationIndex].content : '';
  }
  return '';
};

export const getSoapiTranslationByLocale = (translations, locale) => {
  if (translations && translations.length > 0) {
    let translationIndex = -1;
    let enIndex = 0;
    for (let index = 0; index < translations.length; index += 1) {
      if (translations[index] && translations[index].langs.includes(locale)) {
        translationIndex = index;
      }
      if (translations[index] && translations[index].langs.includes('en')) {
        enIndex = index;
      }
    }
    if (translationIndex === -1) {
      translationIndex = enIndex;
    }
    return translations[translationIndex] ? translations[translationIndex].content : '';
  }
  return '';
};
